/* eslint-disable */
import api from '~/services/api';

export default async (context) => {
  if (context.route?.query?.fk) {
    window.Intercom('boot', {
      app_id: 'nrzl1o5k',
      name: 'Guest',
      // email: customer.email,
      // user_id: customer.id,
    });
    return;
  }
  if (!context.$cookies?.get('auth')?.token) {
    window.Intercom('boot', {
      app_id: 'nrzl1o5k',
      name: 'Business Central Login',
      // email: customer.email,
      // user_id: customer.id,
    });
    return;
  }
  let customer = context.store.state.auth?.customer;
  let company = context.store.state.auth?.company;
  if (!customer || !company) {
    // console.log('Load customer details');
    customer = await api.getCustomer(context);
    company = await api.getCompany(context);
  }

  const customerName = `${customer.firstName} ${customer.lastName} | ${company.name}`;
  // console.log('init customer', customerName);

  window.Intercom('boot', {
    app_id: 'nrzl1o5k',
    name: customerName,
    email: customer.email,
    user_id: customer.id,
  });
};
